var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "log-box sec" }, [
    _c(
      "form",
      {
        staticClass: "gen-form packages",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.saveProfile($event)
          }
        }
      },
      [
        _c("h3", [_vm._v("Tests taken")]),
        _vm._v(" "),
        _vm._l(_vm.tests, function(test) {
          return _c("div", { staticClass: "testtake" }, [
            _c("div", { staticClass: "expires" }, [
              test.video
                ? _c("div", { staticClass: "name" }, [
                    _vm._v(
                      _vm._s(
                        test.video.parent
                          ? test.video.parent.subtitle
                          : test.video.subtitle
                      ) +
                        " " +
                        _vm._s(test.video.title)
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !test.completed
                ? _c("div", { staticClass: "not-completed" }, [
                    _c("span", [_vm._v("Not completed")])
                  ])
                : _c("div", { staticClass: "completed" }, [
                    _c("span", [_vm._v("Completed")]),
                    _vm._v(" "),
                    _c("em", [
                      _vm._v(
                        "correct " +
                          _vm._s(test.completed.result) +
                          " of " +
                          _vm._s(
                            test.completed.answers.questions.questions.length
                          )
                      )
                    ])
                  ])
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "update",
                staticStyle: { cursor: "pointer" },
                attrs: { title: "Allow again" },
                on: {
                  click: function($event) {
                    return _vm.allowAgain(test.id)
                  }
                }
              },
              [_vm._v("Allow again")]
            )
          ])
        }),
        _vm._v(" "),
        !_vm.tests.length
          ? _c("div", [
              _c("div", { staticClass: "none" }, [_vm._v("(no tests taken)")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h3", [_vm._v("Current subscriptions")]),
        _vm._v(" "),
        _vm._l(_vm.item.activePayments, function(payment) {
          return _c("div", { staticClass: "package" }, [
            _c("div", { staticClass: "name" }, [
              _vm._v(
                _vm._s(
                  payment.video
                    ? (_vm.videosById[payment.video] &&
                      _vm.videosById[payment.video].password
                        ? "Test: "
                        : "Video: ") +
                        _vm.completeTitle(_vm.videosById[payment.video])
                    : payment.videogroup && payment.videogroup.title
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "expires" },
              [
                _vm._v("Expires: "),
                _c("datepicker", {
                  model: {
                    value: payment.endDate,
                    callback: function($$v) {
                      _vm.$set(payment, "endDate", $$v)
                    },
                    expression: "payment.endDate"
                  }
                }),
                _c(
                  "a",
                  {
                    staticClass: "update",
                    on: {
                      click: function($event) {
                        return _vm.doUpdate(payment)
                      }
                    }
                  },
                  [_vm._v("✓")]
                ),
                _c(
                  "a",
                  {
                    staticClass: "remove",
                    on: {
                      click: function($event) {
                        return _vm.doRemove(payment)
                      }
                    }
                  },
                  [_vm._v("×")]
                )
              ],
              1
            )
          ])
        }),
        _vm._v(" "),
        !_vm.item.activePayments.length
          ? _c("div", [
              _c("div", { staticClass: "none" }, [
                _vm._v("(no active subscriptions)")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h3", [_vm._v("New subscription")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-row" }, [
          _c("label", [_vm._v("Package subscription")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newPackage,
                  expression: "newPackage"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.newPackage = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.packageOpts, function(option, optVal) {
              return _c("option", { domProps: { value: optVal } }, [
                _vm._v(_vm._s(option))
              ])
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-row" },
          [
            _c("div", { staticClass: "row-split" }, [
              _c("label", [_vm._v("Expiry date")]),
              _vm._v(" "),
              _c("label", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newIndefinite,
                      expression: "newIndefinite"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.newIndefinite)
                      ? _vm._i(_vm.newIndefinite, null) > -1
                      : _vm.newIndefinite
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.newIndefinite,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.newIndefinite = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.newIndefinite = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.newIndefinite = $$c
                      }
                    }
                  }
                }),
                _c("em"),
                _vm._v(" Indefinite")
              ])
            ]),
            _vm._v(" "),
            !_vm.newIndefinite
              ? _c("datepicker", {
                  model: {
                    value: _vm.newExpires,
                    callback: function($$v) {
                      _vm.newExpires = $$v
                    },
                    expression: "newExpires"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-row" },
          [
            _c("div", { staticClass: "row-split" }, [
              _c("label", [_vm._v("Start date")]),
              _vm._v(" "),
              _c("label", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newNow,
                      expression: "newNow"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.newNow)
                      ? _vm._i(_vm.newNow, null) > -1
                      : _vm.newNow
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.newNow,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.newNow = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.newNow = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.newNow = $$c
                      }
                    }
                  }
                }),
                _c("em"),
                _vm._v(" Now")
              ])
            ]),
            _vm._v(" "),
            !_vm.newNow
              ? _c("datepicker", {
                  model: {
                    value: _vm.newStart,
                    callback: function($$v) {
                      _vm.newStart = $$v
                    },
                    expression: "newStart"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-row row-buttons" }, [
          _c(
            "button",
            {
              staticClass: "lbtn",
              attrs: {
                disabled:
                  !_vm.newPackage || (!_vm.newExpires && !_vm.newIndefinite)
              }
            },
            [_vm._v("Activate")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-row row-buttons" }, [
          _c(
            "button",
            {
              staticClass: "lbtn",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.sendEmail($event)
                }
              }
            },
            [_vm._v("Send welcome email")]
          )
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Past subscriptions")]),
        _vm._v(" "),
        _vm._l(_vm.pastPayments, function(payment) {
          return _c("div", { staticClass: "package" }, [
            _c("div", { staticClass: "name" }, [
              _vm._v(_vm._s(payment.videogroup && payment.videogroup.title)),
              _c("br"),
              _vm._v(
                _vm._s(
                  payment.video && _vm.videosById[payment.video]
                    ? _vm.videosById[payment.video].title
                    : ""
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "expires" },
              [
                _vm._v("Expires: "),
                _c("datepicker", {
                  model: {
                    value: payment.endDate,
                    callback: function($$v) {
                      _vm.$set(payment, "endDate", $$v)
                    },
                    expression: "payment.endDate"
                  }
                }),
                _c(
                  "a",
                  {
                    staticClass: "update",
                    on: {
                      click: function($event) {
                        return _vm.doUpdate(payment)
                      }
                    }
                  },
                  [_vm._v("✓")]
                ),
                _c(
                  "a",
                  {
                    staticClass: "remove",
                    on: {
                      click: function($event) {
                        return _vm.doRemove(payment)
                      }
                    }
                  },
                  [_vm._v("×")]
                )
              ],
              1
            )
          ])
        }),
        _vm._v(" "),
        !_vm.pastPayments.length
          ? _c("div", [
              _c("div", { staticClass: "none" }, [
                _vm._v("(no active subscriptions)")
              ])
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }